import React from 'react';
import { cn } from '~/lib/utils';
import styles from './MessageImageGrid.module.css';
import type { ChatTheme } from './theme';
import { chatThemeClass } from './theme';
import { useV15Theme } from '~/design-system/components/v1_5/theme-context';

export interface MessageImageGridProps {
  /**
   * The thumbnails — `ImageThumb size="grid"` (96x64), six of them in *Many screenshots*.
   * Anything narrower than 96px simply packs more per row; the cap is on the grid, not on the
   * tile.
   */
  children: React.ReactNode;
  theme?: ChatTheme;
  className?: string;
}

/**
 * The wrapping grid of screenshots above a user bubble, capped at three tiles wide.
 *
 * `304 = 96 + 8 + 96 + 8 + 96` — the cap is exactly three tiles, so the six thumbnails of
 * `Many screenshots` resolve to 3 / 3, both rows flush to the right edge.
 *
 * **It wraps rather than scrolls, on purpose.** Its sibling `ComposerAttachmentTray` scrolls
 * because it must hold the composer's height steady while you attach; a sent message has no such
 * obligation, and that artboard's caption states the trade outright — *"a scroller hides the
 * count"*. Six screenshots you can see are six screenshots you know you sent.
 */
export function MessageImageGrid({
  children,
  theme: themeProp,
  className,
}: MessageImageGridProps) {
  const theme = useV15Theme(themeProp);
  return (
    <div className={cn(chatThemeClass(theme), styles.grid, className)}>{children}</div>
  );
}
